import React from "react";
import { NavLink, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const NAV = [
  ["/admin/users", "Users"],
  ["/admin/groups", "Groups"],
  ["/admin/content", "Content"],
  ["/admin/part2", "Part 2"],
  ["/admin/live", "Live"],
  ["/admin/reflections", "Reflections"],
  ["/admin/analytics", "Analytics"],
  ["/admin/export", "Export"],
];

export default function AdminLayout({ children }) {
  const { user, logout } = useApp();
  return (
    <div className="rbl" data-testid="admin-app">
      <header className="rbl-topbar">
        <div className="rbl-topbar-inner">
          <div className="rbl-logos">
            <Link to="/admin/users"><img className="rbl-logo" src="/logo_rbl.png" alt="RBL" /></Link>
            <span className="rbl-badge muted">ADMIN</span>
          </div>
          <nav className="rbl-pnav">
            {NAV.map(([to, label]) => (
              <NavLink key={to} to={to} data-testid={`anav-${label.toLowerCase().replace(/\s+/g, "")}`}
                className={({ isActive }) => (isActive ? "active" : "")}>{label}</NavLink>
            ))}
          </nav>
          <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
            <span style={{ fontSize: 13, color: "var(--muted)" }}>{user?.full_name}</span>
            <button className="rbl-link" onClick={logout} data-testid="logout-btn" style={{ border: "none", background: "none" }}>Log out</button>
          </div>
        </div>
      </header>
      <div className="rbl-wrap" style={{ paddingTop: 28, paddingBottom: 50 }}>{children}</div>
    </div>
  );
}
